import React from 'react';
import SideNav from '../side-nav';
// import Icon from '../../../components/shared/icon';
// import FilterIcon from '../../../assets/icons/filter.svg';
import ProductFilters from '../product-filters';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
// import { Accordion, Button } from 'react-bootstrap';

function SidePanel() {

  const { t: trans } = useTranslation();

  const products = useSelector(state => state.products.data);

  const categories = [...new Set(products?.map(item => item.categoryName))]
    .map(item => ({
      title: item,
      route: item ? item.toLowerCase() : '-'
    }));

  categories.unshift({
    title: trans('aside.all'),
    route: 'all'
  })

  // const Filter = [
  //   { title: 'Best Match', route: '' },
  //   { title: 'New', route: '' },
  //   { title: 'Trending', route: '' },
  //   { title: 'Popular', route: '' },
  // ]

  return (
    <section className="side-panel-ue">
      <section className="filter-section">
        <h3>Produkt Typer</h3>
        <ProductFilters/>
      </section>
      <h3 className='section-title'>{trans('aside.categories.title')}</h3>
      <SideNav links={categories} defaultActive="/home" />
      {/* 
      <DropdownButton
        alignRight
        variant="link"
        title={<Icon icon={FilterIcon} classes="sm" />}
        id="dropdown-menu-align-right"
      >
        {Filter.map((item, index) => {
          return <Dropdown.Item key={index} eventKey={index + 1}>{item.title}</Dropdown.Item>
        })} */}
      {/* <Dropdown.Divider />
        <Dropdown.Item eventKey="4">Clear</Dropdown.Item> */}
      {/* </DropdownButton> */}

      {/* <Accordion defaultActiveKey="filt">
        <Accordion.Toggle as={Button} variant="link" eventKey="filt">
          <h3>Filter</h3>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="filt">
          <SideNav classes="filter-panel" links={Filter} defaultActive="/bmatching" />
        </Accordion.Collapse>
      </Accordion> */}
    </section>
  );
}

export default SidePanel;